import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, Input, ViewChild, NgZone } from '@angular/core';

import { SlickComponent } from 'ngx-slick';

import { Banner } from '@shared/data';

@Component({
  moduleId: 'module.id',
  selector: 'banner-slider',
  styles: [require('./banner-slider.component.scss')],
  template: require('./banner-slider.component.html')
})
export class BannerSliderComponent implements OnInit, AfterViewInit {
  @Input()
  public banner: Banner;

  @Input()
  public lang: string;

  @ViewChild('slider')
  public slider: SlickComponent;

  public config = {
    arrows: false,
    dots: true,
    dotsClass: 'custom-dots container',
    slidesToShow: 1
  };

  constructor(private zone: NgZone) {

  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit() {

  }

  public ngAfterViewInit() {

  }

  public onAfterChange() {

  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+home/banner-slider/banner-slider.component.ts